import { useState, useRef } from "react";

import { Table } from "antd";
import useSearchableColumns from "../../hooks/useSeachableColumns";
import "../../styles/components/pvTable.scss";

const PvTable = ({
  data,
  columns,
  onRowClick,
  maxActiveRow = 10,
  reverse = true,
  loading,
  style,
  className,
  tableLayout,
  scroll,
  interactiveRows = false,
  getRowAriaLabel,
  rowStyle,
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const searchableColumn = useSearchableColumns(
    columns,
    searchText,
    setSearchText,
    searchedColumn,
    setSearchedColumn,
    searchInput
  );

  return (
    <Table
      className={className}
      style={style}
      columns={searchableColumn}
      loading={loading}
      dataSource={reverse ? [...data].reverse() : data}
      size="small"
      tableLayout={tableLayout}
      scroll={scroll}
      pagination={{ pageSize: maxActiveRow }}
      onRow={(record) => {
        const activateRow = () => onRowClick?.(record);

        return {
          "aria-label": interactiveRows
            ? getRowAriaLabel?.(record)
            : undefined,
          className: interactiveRows
            ? "pv-table__interactive-row"
            : undefined,
          style: rowStyle ? rowStyle(record) : undefined,
          onClick: activateRow,
          onKeyDown: interactiveRows
            ? (event) => {
                if (event.key !== "Enter" && event.key !== " ") return;

                event.preventDefault();
                activateRow();
              }
            : undefined,
          tabIndex: interactiveRows ? 0 : undefined,
        };
      }}
    />
  );
};

export default PvTable;
